/**
 * Returns a list of mock resources for testing
 */
const getResources = () => {
    return [
        {
            id: 1,
            name: 'Meeting Room 101',
            capacity: { current: 0, total: 10 },
            features: ['building', 'people', 'computer'],
            timeSlots: [
                { start: 25, end: 50, color: 'bg-blue-400' },
                { start: 65, end: 85, color: 'bg-blue-400' }
            ],
            status: 'available',
            available: false
        },
        {
            id: 2,
            name: 'Conference Room A',
            capacity: { current: 2, total: 20 },
            features: ['building', 'people'],
            timeSlots: [
                { start: 10, end: 30, color: 'bg-red-400' }
            ],
            status: 'reserved',
            available: false
        },
        {
            id: 3,
            name: 'Training Room',
            capacity: { current: 0, total: 30 },
            features: ['building', 'people', 'computer'],
            timeSlots: [],
            status: 'available',
            available: true
        }
    ];
};
export default getResources;
